<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <div :style="getColorIconStyle(colorToHex(),'.7rem')" v-on="on"></div>
    </template>

    <v-container style="background-color: #ffffff">
      <div>
        <color-picker v-bind="color"
                      @change="(v) => onInput(v, (sColor) => $emit('updated', {color :sColor, alpha}))">
        </color-picker>
      </div>
      <div style="padding: 1rem 0" @click="(e) => e.stopPropagation()">
        <v-slider v-model="alpha" label="Alpha" max="100" min="10" thumb-label="always"></v-slider>
        <span style="float:right;color:blue; font-weight: 500;cursor:pointer"
              @click="$emit('updated', {color :'', alpha})">Reset</span>
      </div>
    </v-container>
  </v-menu>
</template>

<script>
import color from "@/mixins/color"
import ColorPicker from "@radial-color-picker/vue-color-picker"

export default {
  mixins: [color],
  components: {ColorPicker},
  data() {
    return {
      alpha: 50,
    }
  },
  watch: {
    alpha: function () {
      this.cauculateColorAlpha()
    },
  },
  created() {
    this.cauculateColorAlpha()
  },
  methods: {
    cauculateColorAlpha() {
      this.color.alpha = this.alpha == 0 ? 0 : this.alpha / 100
    }
  }
}
</script>

<style scoped>

</style>